import { useCallback, useEffect, useState } from 'react';
import { ClientStatusError } from '../model/ClientStatusError';
import { useClientStatusContext } from '../context/ClientStatusContext';

type ReturnType = {
  getFieldErrorMessage: (fieldName: string) => string,
  clearAllFieldErrorMessages: () => void,
  clearFieldErrorMessage: (fieldName: string) => void;
};

export default (): ReturnType => {
  const [fieldErrors, setFieldErrors] = useState<Array<ClientStatusError>>([]);
  const { status } = useClientStatusContext();

  useEffect(() => {
    setFieldErrors(status ? status.fieldErrors : []);
  }, [status]);

  const clearAllFieldErrorMessages = useCallback(() => {
    setFieldErrors([]);
  }, []);

  const clearFieldErrorMessage = useCallback((fieldName: string): void => {
    setFieldErrors(fieldErrors.filter(error => error.fieldName !== fieldName));
  }, [fieldErrors]);

  const getFieldErrorMessage = (fieldName: string): string => fieldErrors
    .find(error => error.fieldName === fieldName)?.message;

  return { getFieldErrorMessage, clearAllFieldErrorMessages, clearFieldErrorMessage };
};
